module.exports = __webpack_public_path__ + "img/hover_icon_rubric_setting.26e2321a.svg";